import React, { useCallback, useContext, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useManutencaoFiscal } from '../../ManutencaoFiscalContext';
import { FaHistory } from 'react-icons/fa';
import { BiCheck } from 'react-icons/bi';
import {
  InputNumber,
  InputText,
  InputTextArea,
} from '~/components/NovosInputs';
import { Row, Col } from 'react-bootstrap';
import { ModalHistoryCCe } from './ModalHistoryCCe';
import { ContainerGrid } from './styles';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { toast } from 'react-toastify';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import api from '~/services/api';
import { LojaContext } from '~/context/loja';
import { cartaServices } from '../../services/cartaCorrecao';

const MySwal = withReactContent(Swal);
export const ModalCartaCorrecao: React.FC = () => {
  const [isTransmitting, setIsTransmitting] = useState(false);
  const {
    getValues,
    openModalCarta,
    registerCarta,
    controlCarta,
    formStateCarta,
    handleSubmitCarta,
    resetCarta,
    openHistoryCarta,
    handleOpenModalCarta,
    handleOpenHistoryCarta,
  } = useManutencaoFiscal();
  const { errors } = formStateCarta;
  const { loja } = useContext(LojaContext);
  const { transmitirCCe } = cartaServices;

  const getHistory = async () => {
    handleOpenHistoryCarta(true);
  };

  const handleCloseModal = () => {
    if (!isTransmitting) {
      handleOpenModalCarta(false);
    }
  };

  const handleSendEmail = useCallback(async () => {
    try {
      const { cod_seq_nf, email, num_nf, numSerieNF, chave_nfe, dtaEmissao } =
        getValues();
      if (!email) {
        return;
      }
      await api.get('/manutencao-fiscal/email', {
        params: {
          email,
          num_nf,
          num_serie_nf: numSerieNF,
          dtaEmissao,
          chave_nfe,
          cod_seq_nf,
          cod_loja: loja.cod_loja,
          des_loja: loja.des_loja,
        },
      });
      return true;
    } catch (error: any) {
      toast.error(error.message);
      return false;
    }
  }, [getValues, loja]);

  const onSaveCarta = handleSubmitCarta(async (data) => {
    const { cod_seq_nf, flg_cancelada, chave_nfe, flg_nfe_pendente, email } =
      getValues();

    if (flg_nfe_pendente) {
      return toast.warn(
        'É necessário transmitir a NFe para fazer uma Carta de Correção. ',
      );
    }
    if (flg_cancelada) {
      return toast.warn(
        'Não é possível fazer Carta de Correção para NF cancelada.',
      );
    }
    if (!chave_nfe || chave_nfe === undefined || chave_nfe === 'undefined') {
      return toast.warn('Chave de Acesso deve possuir 44 dígitos');
    }
    if (!email) {
      const confirm = await MySwal.fire({
        text: 'Não existe e-mail cadastrado para o destinatário. Deseja continuar?',
        showCancelButton: true,
        confirmButtonColor: '#07289e',
        cancelButtonColor: '#ff7b7b',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then(async (result) => {
        return result.isConfirmed;
      });
      if (!confirm) return Swal.close();
    }

    const { num_cnpj, des_uf, parametro_nfe, cod_loja } = loja;
    const { tipo_ambiente } = parametro_nfe;

    const insertValues = {
      cod_seq_nf,
      num_seq: data.num_seq,
      des_titulo: data.des_titulo.trim(),
      des_cce: data.des_cce.trim(),
      cod_loja,
      ambiente: tipo_ambiente,
      chave_nfe,
      cnpj: num_cnpj,
      uf: des_uf,
    };

    setIsTransmitting(true);
    try {
      const res = await transmitirCCe(insertValues);
      const { success, message } = res;

      if (success) {
        resetCarta();
        toast.success(message);
        handleOpenModalCarta(false);
        if (!(await handleSendEmail())) return;
        return;
      }
      toast.warn(message);
    } finally {
      setIsTransmitting(false);
    }
  });

  return (
    <ContainerGrid>
      {openHistoryCarta && <ModalHistoryCCe />}
      <Modal
        show={openModalCarta}
        centered
        onHide={handleCloseModal}
        backdrop={isTransmitting ? 'static' : true}
        keyboard={!isTransmitting}
        size="xl"
      >
        <Modal.Header>
          <Modal.Title>Carta de Correção Eletrônica (CCe)</Modal.Title>
          <button
            type="button"
            onClick={handleCloseModal}
            disabled={isTransmitting}
            style={{
              right: '10px',
              top: '10px',
              fontSize: '20px',
              cursor: isTransmitting ? 'not-allowed' : 'pointer',
              outline: 'none',
              background: 'none',
              border: 'none',
              opacity: isTransmitting ? 0.5 : 1,
            }}
          >
            x
          </button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={12} md={2}>
              <InputNumber
                name="num_seq"
                label="Número"
                disabled
                control={controlCarta}
                register={registerCarta}
                min={0}
                max={999}
                maxLength={15}
                placeholder="0"
                isError={!!errors.num_seq}
              />
            </Col>
            <Col sm={12} md={8}>
              <InputText
                label="Título"
                name="des_titulo"
                caseInput="upper"
                control={controlCarta}
                register={registerCarta}
                maxLength={50}
                isError={!!errors.des_titulo}
              />
            </Col>
            <Col sm={12} md={2} className="d-flex justify-content-end">
              <CustomButtonNovo
                onClick={() => getHistory()}
                width="200px"
                label="Histórico"
                icon={FaHistory}
                disabled={false}
                style={{
                  backgroundColor: '#007bff',
                  marginTop: '30px',
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12}>
              <InputTextArea
                style={{ height: '150px' }}
                label="Descrição"
                name="des_cce"
                control={controlCarta}
                register={registerCarta}
                minLength={15}
                maxLength={999}
                isError={!!errors.des_cce}
              />
            </Col>
          </Row>
          <Row className="align-items-center mt-3">
            <Col sm={12} md={8} className="d-flex align-items-center">
              <span
                style={{
                  color: 'red',
                  fontSize: '21px',
                }}
              >
                Todas alterações informadas na CCe devem ser feitas na
                Manutenção Fiscal.
              </span>
            </Col>
            <Col sm={12} md={4} className="d-flex justify-content-end">
              <CustomButtonNovo
                onClick={() => onSaveCarta()}
                width="200px"
                label="Transmitir CCe"
                icon={BiCheck}
                disabled={isTransmitting}
                showLoading={isTransmitting}
                style={{
                  backgroundColor: '#28a745',
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </ContainerGrid>
  );
};
